import React from 'react';
import {RFValue} from 'react-native-responsive-fontsize';

import {Container, FilterText} from './styles';

interface IFIlterItem {
  rank?: 'gold' | 'silver';
  title: string;
  onPress: () => void;
  mr?: number;
}

export function FilterStationsCategory({
  title,
  rank,
  mr,
  onPress,
}: IFIlterItem) {
  const spacing = mr === 0 ? 0 : mr ? mr : RFValue(8);
  const growFactor = Math.max(title.length, 1);

  return (
    <Container
      rank={rank}
      activeOpacity={0.7}
      onPress={onPress}
      style={{
        marginRight: spacing,
        flexGrow: growFactor,
      }}>
      <FilterText rank={rank}>{title}</FilterText>
    </Container>
  );
}
